import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { colors } from '../tokens'

const useStyles = makeStyles({
  root: {
    display: 'flex',
    gap: '4px',
    flexWrap: 'wrap',
    borderBottom: `1px solid ${colors.border}`,
  },
  tab: {
    marginBottom: -1,
    padding: '10px 14px',
    border: 0,
    borderBottom: '2px solid transparent',
    background: 'transparent',
    cursor: 'pointer',
    fontFamily: 'inherit',
    fontSize: '13px',
    fontWeight: 500,
    color: colors.muted,
    whiteSpace: 'nowrap',
  },
  active: {
    color: colors.primary,
    borderBottomColor: colors.primary,
  },
})

/**
 * Text tabs with a blue underline on the active one.
 *
 * @param {{ value: string, label: string }[]} tabs
 */
const UnderlineTabs = ({ tabs, value, onChange }) => {
  const classes = useStyles()

  return (
    <div className={classes.root} role="tablist">
      {tabs.map(tab => (
        <button
          key={tab.value}
          type="button"
          role="tab"
          aria-selected={tab.value === value}
          className={`${classes.tab} ${
            tab.value === value ? classes.active : ''
          }`}
          onClick={() => onChange(tab.value)}
        >
          {tab.label}
        </button>
      ))}
    </div>
  )
}

export default UnderlineTabs
